/* import __COLOCATED_TEMPLATE__ from './admins-viewing.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type Session from 'embercom/services/session';
import type RealtimeWorkflowParticipants from 'embercom/services/realtime-workflow-participants';
import { type WorkflowViewerInfo } from 'embercom/services/realtime-workflow-participants';

interface Args {
  rulesetId: number;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
}

export default class WorkflowsEditorAdminsViewing extends Component<Signature> {
  @service declare realtimeWorkflowParticipants: RealtimeWorkflowParticipants;
  @service declare session: Session;

  get admins(): WorkflowViewerInfo[] {
    return this.realtimeWorkflowParticipants.adminsViewingWorkflow(this.args.rulesetId);
  }

  get hasAdmins(): boolean {
    return this.admins.length > 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::Editor::AdminsViewing': typeof WorkflowsEditorAdminsViewing;
    'workflows/editor/admins-viewing': typeof WorkflowsEditorAdminsViewing;
  }
}
